export default () => ({
    open: false, 
    openModal() {
      console.log('openModal');
      this.open = true;
      // document.getElementById('swup').classList.toggle('dim');
    },
    closeModal() {
      console.log('closeModal');
      this.open = false;
    },
    get modalClass() {
      return this.open ? 'open' : '';
    }
})